export const config = {
  environment: 'prod',

  // PROD Backend URL
  apiUrl: 'https://odm-portal-backend-c2b8gehtamasfrdg.germanywestcentral-01.azurewebsites.net',

  // Azure AD Authentication (TEMPORARILY USING UAT VALUES - UPDATE LATER)
  azureClientId: '987c59bd-28f8-4044-9533-2c797df27ec5',
  azureTenantId: '6e06e42d-6925-47c6-b9e7-9581c7ca302a',
  msalRedirectUri: 'https://odm.allianz.com',

  // Azure AD Security Groups (PROD)
  adminGroupId: 'ac48d0ac-c845-4d2b-aa9d-4214a0e0681c',        // ODM-PROD-ADMIN
  requestorGroupId: '9114dd3e-f092-4a8f-ac97-7552a093b2ab'     // ODM-PROD-REQUESTOR
};
